import { useTranslation } from 'react-i18next';

export default function SolutionSection() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-folder-open-line', text: t('solution.feature1') },
    { icon: 'ri-eye-line', text: t('solution.feature2') },
    { icon: 'ri-shield-check-line', text: t('solution.feature3') },
    { icon: 'ri-user-heart-line', text: t('solution.feature4') },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-white">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              {t('solution.title')}
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed text-base">
              {t('solution.desc')}
            </p>
            <div className="mt-8 space-y-3">
              {features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-3 text-foreground-700">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${feat.icon} text-xs`}></i>
                  </div>
                  <span className="text-sm">{feat.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200/70">
                      <th className="text-left py-3 px-3 font-label text-xs uppercase text-foreground-500 tracking-wider">Товар</th>
                      <th className="text-left py-3 px-3 font-label text-xs uppercase text-foreground-500 tracking-wider">Ссылка</th>
                      <th className="text-left py-3 px-3 font-label text-xs uppercase text-foreground-500 tracking-wider">Цена</th>
                      <th className="text-left py-3 px-3 font-label text-xs uppercase text-foreground-500 tracking-wider">Кол-во</th>
                      <th className="text-left py-3 px-3 font-label text-xs uppercase text-foreground-500 tracking-wider">Статус</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-100">
                      <td className="py-3 px-3 text-foreground-800">Sneakers</td>
                      <td className="py-3 px-3 text-accent-600">Taobao</td>
                      <td className="py-3 px-3 text-foreground-800">$25</td>
                      <td className="py-3 px-3 text-foreground-800">1</td>
                      <td className="py-3 px-3">
                        <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">Ordered</span>
                      </td>
                    </tr>
                    <tr className="border-b border-background-100">
                      <td className="py-3 px-3 text-foreground-800">Jacket</td>
                      <td className="py-3 px-3 text-accent-600">1688</td>
                      <td className="py-3 px-3 text-foreground-800">$15</td>
                      <td className="py-3 px-3 text-foreground-800">2</td>
                      <td className="py-3 px-3">
                        <span className="inline-block px-2.5 py-0.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium">In warehouse</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="py-3 px-3 text-foreground-800">T-Shirt</td>
                      <td className="py-3 px-3 text-accent-600">Taobao</td>
                      <td className="py-3 px-3 text-foreground-800">$8</td>
                      <td className="py-3 px-3 text-foreground-800">3</td>
                      <td className="py-3 px-3">
                        <span className="inline-block px-2.5 py-0.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">Shipped</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}